<template>
    <div v-if="unbalanceList.length" class="alert-msg-container">
        <div v-for="item in unbalanceList" :key="item.accno" class="alert-msg">
            <div>
                <i class="el-icon-warning" style="margin-right: 5px"></i>
                <span>提醒您：「{{ item.accnonam }}」尚未全額沖銷。</span>
            </div>
            <span style="font-size: 10pt; font-weight: normal">（差額：<money :v="Math.abs(item.balance)" />）</span>
        </div>
    </div>
</template>

<script>
import _ from 'lodash';
import { getTotalCrd, getTotalDeb, basicVoucherJudge } from './mixinFunctions';

export default {
    props: {
        datas: {
            type: Object,
            default: () => ({}),
        },
        vouchers: {
            type: Array,
            default: () => [],
        },
    },
    computed: {
        unbalanceList() {
            if (!basicVoucherJudge(this.datas, this.vouchers)) return false;

            const LIST = _.chain(this.vouchers)
                .flatMap('accountItems')
                .filter((o) => `${o.accno}`.includes('1130'))
                .uniqBy('accno')
                .map((o) => ({
                    ...o,
                    accno: o.accno,
                    totalCrd: getTotalCrd(this.vouchers, o.accno),
                    totalDeb: getTotalDeb(this.vouchers, o.accno),
                    balance: getTotalCrd(this.vouchers, o.accno) - getTotalDeb(this.vouchers, o.accno),
                }))
                .filter((o) => o.balance !== 0)
                .value();

            console.log(LIST);

            return LIST;
        },
    },
};
</script>

